import { useState } from "react";

const CourseCard = ({ courseName, color, web}) => {
    const colorVariants = {
        'darkBlue': 'bg-custom-darkBlue-600',
        'clearBlue': 'bg-custom-clearBlue-300',
        'clearBlue-400': 'bg-custom-clearBlue-400',
        'darkBlue-300': 'bg-custom-darkBlue-600'
    }

    const colorVariantsHov = {
        'darkBlue': 'bg-custom-darkBlue-700',
        'clearBlue': 'bg-custom-clearBlue-400',
        'clearBlue-400': 'bg-custom-clearBlue-500',
        'darkBlue-300': 'bg-custom-darkBlue-700'
    }

    const [isHovered, setIsHovered] = useState(false);

    return (
        <a href={web} target="_blank nonerreferer">
        <div className="group">
            <div 
                className={`${isHovered ? colorVariantsHov[color] : colorVariants[color] } shadow-lg rounded-lg p-8 mb-2 hover:underline`} 
                style={{textDecorationColor: 'white'}}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <p className="text-md text-white font-semibold md:text-sm">
                    {courseName}
                    <i className="fa fa-angle-double-right ml-1 leading-relaxed"></i>
                </p>                
            </div>
        </div>
        </a>
    )
}

export default CourseCard;